/* eslint-disable */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import React, { useCallback, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import BenefitsService from 'src/services/benefits.service';
import { IBenefitType } from 'src/interfaces';
import EnrollmentChangesCard from '../enrollment-changes-card';
import {
  EnrollmentChangesContainer,
  EnrollmentChangesTitle,
  EnrollmentChangesGridContainer,
  EnrollmentTypeTitle,
} from './styles';
import { benefitsCategories } from '../..';

import { RegularButton } from 'pg-ui-library';

import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

type EnrollmentChangesType = {
  categories?: string[];
  enabledHeader?: boolean;
  eventType?: string;
};

const EnrollmentChanges: React.FC<EnrollmentChangesType> = ({
  categories = benefitsCategories,
  enabledHeader = true,
  eventType,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { enrollmentType } = useTypedSelector(state => state.benefits.data);

  const [itemObject, setItemObject] = useState<{ [key: string]: IBenefitType[] }>({});
  const [hasDataError, setHasDataError] = useState(false);
  const [missingDataMessage, setMissingDataMessage] = useState<string>('');

  const extractMissingDataFromError = (errorMessage: string): string => {
    // Tentar extrair a informação específica que está faltando da mensagem
    // Suporta tanto "Missing required employee data:" quanto "Missing benefit configuration:"
    const employeeDataMatch = errorMessage.match(/Missing required employee data: (.+?)\./);
    const benefitConfigMatch = errorMessage.match(/Missing benefit configuration: (.+?)\./);

    if (employeeDataMatch) {
      return employeeDataMatch[1];
    }
    if (benefitConfigMatch) {
      return benefitConfigMatch[1];
    }

    // Se não encontrar padrão específico, retorna a mensagem completa até o ponto final
    const genericMatch = errorMessage.match(/(.+?)\./);
    return genericMatch ? genericMatch[1] : errorMessage;
  };

  let { data: types, isLoading } = useQuery({
    queryKey: ['benefits/benefits-types', eventType],
    queryFn: () => BenefitsService.getBenefitTypes(eventType),
    enabled: true,
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || '';
      const statusCode = error?.response?.status;

      if (statusCode === 422) {
        // UnprocessableEntityException - dados faltando
        setHasDataError(true);
        const missingData = extractMissingDataFromError(errorMessage);
        setMissingDataMessage(missingData);
      }
    },
  });

  const handleBenefitsByEnrollmentType = () => {
    let initialTypes = types;

    if (enrollmentType === 'qle') {
      initialTypes = initialTypes?.filter(type => type.whenEmployeeCanEnroll?.includes('QLE'));
    }

    if (enrollmentType === 'update_enrollment') {
      initialTypes = initialTypes?.filter(type => type.whenEmployeeCanEnroll?.includes('UE'));
    }

    const newItemObject: { [key: string]: IBenefitType[] } = {};

    categories.forEach(item => {
      newItemObject[item] = [];
    });
    console.log('categories', categories);

    initialTypes?.forEach(type => {
      // Prevents backend null value error
      if (type.type && type.generalCategory && type.generalCategory?.trim() !== '') {
        if (categories.includes(type.generalCategory)) {
          newItemObject[type.generalCategory].push(type);
        }
      }
    });

    setItemObject(newItemObject);
  };

  useEffect(() => {
    handleBenefitsByEnrollmentType();
  }, [enrollmentType, types]);

  return (
    <EnrollmentChangesContainer>
      {enabledHeader && (
        <>
          <div></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <EnrollmentChangesTitle>{t('benefits.enrollment.title')}</EnrollmentChangesTitle>
            <div style={{ display: 'flex', marginTop: '2%' }}>
              <RegularButton
                type="button"
                style={{ marginRight: '40px', marginTop: '13px' }}
                onClick={() => navigate('/personal-information')}
              >
                {t('global.form.add')} Dependent
              </RegularButton>
            </div>
          </div>
        </>
      )}

      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '40px 20px',
            fontSize: '16px',
            color: '#666',
          }}
        >
          Loading benefits...
        </div>
      ) : hasDataError ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '40px 20px',
            gap: '15px',
          }}
        >
          <div
            style={{
              fontSize: '48px',
              color: '#ff9800',
            }}
          >
            ⚠️
          </div>
          <div
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#333',
              textAlign: 'center',
            }}
          >
            Missing Required Information
          </div>
          <div
            style={{
              fontSize: '14px',
              color: '#666',
              textAlign: 'center',
              maxWidth: '500px',
            }}
          >
            {missingDataMessage}
          </div>
          <div
            style={{
              fontSize: '14px',
              color: '#666',
              textAlign: 'center',
              marginTop: '10px',
            }}
          >
            Please contact support to update your employee information.
          </div>
        </div>
      ) : (
        categories.map(category => {
          {
            return itemObject[category]?.length > 0 ? (
              <div key={category}>
                {enabledHeader && <EnrollmentTypeTitle>{category}</EnrollmentTypeTitle>}
                <EnrollmentChangesGridContainer key={category}>
                  {itemObject[category]?.map((item, index: number) => (
                    <EnrollmentChangesCard
                      key={index}
                      type={item.type}
                      imgURL={item.imgURL}
                      mandatory={item.mandatory}
                      blockerTypes={item.blockerTypes}
                      spouseMaxAge={item.spouseMaxAge}
                      spouseAge={item.spouseAge}
                    />
                  ))}
                </EnrollmentChangesGridContainer>
              </div>
            ) : (
              <div key={category} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {t('benefits.benefit.nonAvailables')}
              </div>
            );
          }
        })
      )}
    </EnrollmentChangesContainer>
  );
};

export default EnrollmentChanges;
